import { Component, OnInit, OnDestroy, ElementRef, Renderer2 } from '@angular/core';
import { PlessAlertComponent, PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { faExclamationTriangle, faTimesCircle, IconDefinition} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'pless-alert-sub',
  templateUrl: './pless-alert-sub.component.html',
  styleUrls: ['./pless-alert-sub.component.scss'],
})

export class PlessAlertSubComponent extends PlessAlertComponent {

  /** アイコン画像 */
  faErrorIcon = faExclamationTriangle;
  faSystemErrorIcon = faTimesCircle;

  public messageIcon: IconDefinition = this.faErrorIcon;
  public messageIconStyleClass: string = '';
  public iconVisibleFlg: string = 'none';

  constructor(public elementRef: ElementRef, public renderer: Renderer2) {
    super(elementRef, renderer);
  }

  /**
   * アラートに表示するデータを設定
   *
   * @param {string} text 表示する文字列(改行は\nで指定)
   * @param {string} [title] アラートのタイトル
   * @param {Array<PlessAlert>} [buttons] 表示するボタン
   * @param {Number} [defaultButton] デフォルト選択ボタン
   * @memberof PlessAlertComponent
   */
  setData(text: string, title?: string, buttons?: Array<PlessAlert>, defaultButton?: number) {
    // アラートタイトル、アイコン画像を設定
    switch (title.substr(0, 1)) {
      case 'E':
      case 'W':
        title = 'エラー';
        // アイコンの種類とスタイル指定
        this.messageIcon = this.faErrorIcon;
        this.messageIconStyleClass = 'error-icon-style';
        this.iconVisibleFlg = 'block';
        if ( buttons === undefined ) {
          // レスポンスからエラーIDが返ってきたときはボタンの指定がundefinedのため
          buttons = [PlessAlert.Yes_Error];
          defaultButton = PlessAlert.Yes_Error;
        }
        break;
      case 'S':
        if ( buttons === undefined ) {
          // レスポンスからエラーIDが返ってきたときにボタンの指定がundefinedのため
          buttons = [PlessAlert.Yes_Error];
          defaultButton = PlessAlert.Yes_Error;
        }
        if (title === 'S0103') {
          title = 'セッションタイムアウト';
          break;
        }
        text += title.length > 1 ? `\n（エラーコード：${title}）` : ''
        title = 'システムエラー';
        // アイコンの種類とスタイル指定
        this.messageIcon = this.faSystemErrorIcon;
        this.messageIconStyleClass = 'system-error-icon-style';
        this.iconVisibleFlg = 'block';
        break;
      case 'I':
        title = '情報';
        this.iconVisibleFlg = 'none';
        if ( buttons === undefined ) {
          // レスポンスからエラーIDが返ってきたときにボタンの指定がundefinedのため
          buttons = [PlessAlert.Yes];
          defaultButton = PlessAlert.Yes;
        }
        break;
      case 'Q':
        title = '確認';
        this.iconVisibleFlg = 'none';
        if ( buttons === undefined ) {
          // レスポンスからエラーIDが返ってきたときにボタンの指定がundefinedのため
          buttons = [PlessAlert.No, PlessAlert.Yes];
          defaultButton = PlessAlert.No;
        }
      default:
        break;
    }

    super.setData(text, title, buttons, defaultButton);
  }

}
